import React, { useState, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import InteractorReturnApproval from '../../interactors/return/InteractorReturnApproval'
import { confirmationAlert } from '../../utility/SweetAlert'
import { t } from 'i18next'
import { useSelector } from 'react-redux'
import { currencyFormatDecimal } from '../../utility/Helpers'
import { Pagination } from '../../components/Main'

const headers = [
  { label: t('fee.created_date'), key: 'created_date', width: '150px' },
  { label: t('form.return_number'), key: 'retur_code', width: '150px' },
  { label: t('form.reference_number_internal'), key: 'reference_number_internal', width: '150px' },
  { label: t('form.return_amount'), key: 'retur_amount', width: '150px' },
  { label: t('form.retur_note'), key: 'retur_note', width: '150px' },
  { label: t('title.status'), key: 'initial_status', width: '150px' },
  { label: t('title.action'), key: 'actions', width: '150px' },
]

const renderStatus = (status) => {
  const base = 'badge rounded-pill px-3 py-1 fw-medium'
  switch (status) {
    case 'REQUEST':
      return (
        <span className={`${base} bg-warning text-dark`}>{t('status.bill.WAITING_APPROVAL')}</span>
      )
    case 'APPROVED':
      return <span className={`${base} bg-success text-white`}>{t('status.bill.APPROVED')}</span>
    case 'CANCELLED':
      return <span className={`${base} bg-danger text-white`}>{t('status.bill.CANCELLED')}</span>
    case 'REJECTED':
      return <span className={`${base} bg-black text-white`}>{t('status.bill.REJECTED')}</span>
    default:
      return <span className={`${base} bg-secondary`}>{status}</span>
  }
}

const ReturnTable = (dataItems) => {
  const { t } = useTranslation()
  const [expandedRows, setExpandedRows] = useState({})
  const { returnApproval } = InteractorReturnApproval()
  const { data, pagination, onPageChange, onLimitChange } = dataItems
  const { datacard } = data
  const { items } = datacard

  const toggleRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  const cancelReturn = async (e, data) => {
    e.preventDefault()

    let payload = {
      uid: data.uid,
      status: 'CANCELLED',
      retur_note: data.retur_note,
    }
    const confirm = await confirmationAlert({
      title: t('title.are_you_sure'),
      message: t('message.confirmation_cancel_return'),
      icon: 'warning',
    })
    if (confirm) returnApproval(payload, true)
  }

  const stickyStyle = {
    position: 'sticky',
    right: 0,
    backgroundColor: 'white',
    zIndex: 2,
    boxShadow: '-2px 0 5px rgba(0,0,0,0.05)',
  }

  return (
    <div className="w-100 px-3 py-4">
      <div className="d-flex justify-content-end  align-items-center mb-2 flex-wrap gap-2">
        <Link
          to={'/return/create'}
          className="d-inline btn rounded-pill btn-primary btn-xs m-2 font-size-10"
        >
          <i className="fa fa-plus"></i> {t('button.add_return')}
        </Link>
      </div>

      <h6 className="mb-3 fw-semibold text-secondary">{t('form.history_return')}</h6>

      <div className="d-flex justify-content-center">
        <div
          className="table-responsive bg-white rounded shadow-sm w-100"
          style={{ overflowX: 'auto' }}
        >
          <table className="table align-middle mb-0" style={{ minWidth: '1100px' }}>
            <thead className="bg-light text-muted text-uppercase small">
              <tr>
                <th style={{ width: '5%' }}></th> {/* Kolom untuk icon arrow */}
                {headers.map((header) => (
                  <th
                    key={header.key}
                    style={{
                      width: header.width,
                      ...(header.key === 'actions' ? stickyStyle : {}),
                      zIndex: 3,
                    }}
                    className="py-2 px-3 fw-semibold text-black"
                  >
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items && items.length > 0 ? (
                items.map((row, index) => (
                  <Fragment key={index}>
                    <tr
                      className="border-bottom text-dark pointer"
                      onClick={() => toggleRow(index)}
                      style={{
                        fontSize: '0.875rem',
                        backgroundColor: expandedRows[index] ? '#f8f9fa' : 'white',
                      }}
                    >
                      <td className="text-center">
                        <i
                          className={`fas ${
                            expandedRows[index] ? 'fa-chevron-down' : 'fa-chevron-right'
                          } text-muted`}
                        ></i>
                      </td>
                      {headers.map(({ key }) => (
                        <td
                          key={key}
                          className="py-2 px-3 align-middle"
                          style={
                            key === 'actions'
                              ? {
                                  ...stickyStyle,
                                  backgroundColor: expandedRows[index] ? '#f8f9fa' : 'white',
                                }
                              : {}
                          }
                        >
                          {key === 'initial_status' ? (
                            renderStatus(row[key])
                          ) : key === 'retur_amount' ? (
                            currencyFormatDecimal(row[key])
                          ) : key === 'actions' ? (
                            <div
                              className="d-flex justify-content-end gap-2"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Link
                                to={`/return/view/${row.uid}`}
                                className="d-inline btn rounded-pill btn-primary btn-xs my-2 mx-1 font-size-10"
                              >
                                {t('button.view')}
                              </Link>
                              {row.initial_status === 'REQUEST' && (
                                <button
                                  onClick={(e) => cancelReturn(e, row)}
                                  className="btn rounded-pill btn-danger btn-xs my-2 mx-1 font-size-10"
                                  style={{ cursor: 'pointer' }}
                                >
                                  {t('button.cancel')}
                                </button>
                              )}
                            </div>
                          ) : (
                            row[key] || '-'
                          )}
                        </td>
                      ))}
                    </tr>

                    {expandedRows[index] && (
                      <tr>
                        <td colSpan={headers.length + 1} className="p-0 border-0">
                          <div className="bg-light p-3">
                            <div className="card shadow-sm border-0" style={{ maxWidth: '800px' }}>
                              <div className="card-body p-0">
                                <div className="py-2 bg-light border-bottom">
                                  <span
                                    className="fw-bold text-dark"
                                    style={{ fontSize: '0.9rem' }}
                                  >
                                    {t('title.product_info')}
                                  </span>
                                </div>

                                <div className="table-responsive">
                                  <table
                                    className="table table-sm mb-0"
                                    style={{ maxWidth: '650px' }}
                                  >
                                    <thead className="text-gray-50 small">
                                      <tr>
                                        <th className="ps-3 py-2 border-0">
                                          {t('title.product.product_name')}
                                        </th>
                                        <th className="text-center py-2 border-0">
                                          {t('title.product.product_total')}
                                        </th>
                                        <th className="text-center py-2 border-0">
                                          {t('title.product.product_price')}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {row?.retur_lines && row?.retur_lines[0] !== null ? (
                                        row.retur_lines.map((line, idx) => (
                                          <tr key={idx} className="border-top">
                                            <td className="ps-3 py-2 text-secondary">
                                              {line.product_title || '-'}
                                            </td>
                                            <td className="text-center py-2 text-secondary">
                                              {line.product_quantity || 0}{' '}
                                              {line.product_unit_type || ''}
                                            </td>
                                            <td className="text-center py-2 text-secondary">
                                              {currencyFormatDecimal(line.product_price || 0)}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan="3"
                                            className="text-center py-3 text-muted small"
                                          >
                                            {t('message.no_product_detail')}
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan={headers.length + 1} className="text-center py-4">
                    {t('title.no_data')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="container mt-4">
        <Pagination data={pagination} onChangePage={onPageChange} onLimitChange={onLimitChange} />
      </div>
    </div>
  )
}

export default ReturnTable
